import React, { useContext, useState } from 'react';
import { Col, Form, Input, Radio, Row, Select } from 'antd';
import AloneCol from '../../../../../../../../components/common/AloneCol';
import useParams from '../../../../../../../params/useParams';
import paramType from '../../../../../../../params/paramEndpoints';
import tokens from '../../../../../../../../utils/tokens';
import InputRut from '../../../../../../../../components/form/inputs/InputRut';
import { EnrollmentFormContext } from '../../../../../../../../providers/EnrollmentFormContextProvider';
import IdentificationType from '../../../../../../../../enums/identificationType';
import form from '../../../../../../../../utils/form';

const DeclaringLegalPersonForm = () => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [countries, areCountriesLoading] = useParams(paramType.COUNTRIES);
  const [selectedRut, setSelectedRut] = useState(false);

  const toggleRutCheck = () => {
    setSelectedRut(true);
  };

  const togglePassportCheck = () => {
    setSelectedRut(false);
  };

  const gutter = tokens.forms.horizontalGutterInPx;

  return (
    <Form form={enrollmentForm} layout="vertical" validateMessages={form.validateMessages}>
      <Row justify="start" gutter={[gutter]}>
        <Col className="declaringPersonForm__title" span={24}>
          Persona que realiza la presente declaración
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <AloneCol span={12}>
          <Form.Item
            name={['declaringPerson', 'nationality']}
            label="Nacionalidad"
            rules={[{ required: true }]}
          >
            <Select placeholder="Seleccionar" loading={areCountriesLoading}>
              {countries.map(({ id, name }) => (
                <Select.Option key={id} value={id}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </AloneCol>
      </Row>
      <Row gutter={[gutter]}>
        <Col span={24}>
          <Form.Item name={['declaringPerson', 'identificationType']}>
            <Radio.Group defaultValue={1}>
              <Radio value={IdentificationType.RUT} onChange={toggleRutCheck}>
                Rut
              </Radio>
              <Radio value={IdentificationType.PASAPORTE} onChange={togglePassportCheck}>
                Pasaporte
              </Radio>
              <Radio value={IdentificationType.OTRO} onChange={togglePassportCheck}>
                Otro
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col lg={{ span: 12 }} xs={24}>
          <Form.Item
            label="N° de Identificación"
            name={['declaringPerson', 'identification']}
            rules={[
              {
                required: true,
                message: 'N° de Identificación es requerido',
              },
            ]}
          >
            {selectedRut ? <InputRut /> : <Input />}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col span={24}>
          <Form.Item
            label="Nombre"
            name={['declaringPerson', 'name']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Apellido Paterno"
            name={['declaringPerson', 'firstSurname']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Apellido Materno"
            name={['declaringPerson', 'secondSurname']}
            rules={[
              {
                required: false
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Lugar de origen"
            name={['declaringPerson', 'placeOfOrigin']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Select placeholder="Seleccionar" loading={areCountriesLoading}>
              {countries.map(({ id, name }) => (
                <Select.Option key={id} value={id}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item
            label="Relación con la P. Jurídica declarante"
            name={['declaringPerson', 'relationWithLegalPerson']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DeclaringLegalPersonForm;
